export default __webpack_public_path__ + "static/media/visa.a14f73d3.svg";